//modules
import React from 'react';
import { Link } from "react-router-dom";
import { useTextAnimation } from '../globalComponents/UseTextAnimation';

//styles
import './StuffCard.css';
import './ProjectsFooter.css'

export const StuffCard = ({ title, description, image, path, customClass, isExternal, onClick }) => {

  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    } else {
      window.scrollTo(0, 0);
    }
  };

  const { headingRef, subtitleRef } = useTextAnimation();

  return isExternal ? (
    <a
      className="link stuff-card-container"
      href={path}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="card-image-container">
        <img className="card-image" src={image} alt={title} />
      </div>
        <div className="card-content">
          <div className="card-body">
            <p className={`heading-4 title ${customClass || ''}`} ref={headingRef}>{title}</p>
            <p className={`body description truncated-text ${customClass || ''}`} ref={(el) => (subtitleRef.current[0] = el)}>{description}</p>
          </div>
          <div className="stuff-card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none" className="default-class">
              <path d="M10.2215 25.0711L24.3636 10.9289M24.3636 10.9289H10.2215M24.3636 10.9289V25.0711"/>
            </svg>
          </div>
      </div>
    </a>
  ) : (
    <Link className="link stuff-card-container" to={path} onClick={handleClick}>
      <div className="card-image-container">
        <img className="card-image" src={image} alt={title} />
      </div>
      <div className="card-content">
        <div className="card-body">
          <p className={`heading-4 title ${customClass || ''}`} ref={headingRef}>{title}</p>
          <p className={`body description truncated-text ${customClass || ''}`} ref={(el) => (subtitleRef.current[0] = el)}>{description}</p>
        </div>
        <div className="stuff-card-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none" className="custom-class"> 
          <path d="M10.2215 25.0711L24.3636 10.9289M24.3636 10.9289H10.2215M24.3636 10.9289V25.0711"/>
        </svg>
        </div>
      </div>
    </Link>
  );
};
